export enum FormableType {
  text = 1,
  email = 2,
  image = 3,
  layer = 4,
  layout = 5,
  qrcode = 6,
}
